export const AWS_COGNITO = {
  userPoolId: "eu-west-1_ssxv6p6Jz",
  userPoolClientId: "6dp28n7cgk62k7kb6chns4lg18",
};
